'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _FieldsetStyle = require('./FieldsetStyle.scss');

var _FieldsetStyle2 = _interopRequireDefault(_FieldsetStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fieldset = (_dec = (0, _reactCssModules2.default)(_FieldsetStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Fieldset, _React$Component);

  function Fieldset() {
    (0, _classCallCheck3.default)(this, Fieldset);
    return (0, _possibleConstructorReturn3.default)(this, (Fieldset.__proto__ || (0, _getPrototypeOf2.default)(Fieldset)).apply(this, arguments));
  }

  (0, _createClass3.default)(Fieldset, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'fieldset',
        { styleName: 'm-fieldset ' + this.props.extraStyle },
        this.props.children
      );
    }
  }]);
  return Fieldset;
}(_react2.default.Component), _class2.defaultProps = {
  extraStyle: ''
}, _temp)) || _class);
exports.default = Fieldset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Fieldset.js
// module id = 2289
// module chunks = 0